/**
 * ComparePage - Side-by-side document comparison
 * URL: /compare?left=docId1&right=docId2
 * Renders two DocumentViewPro instances side by side
 */

import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Typography, Alert } from '@mui/material';
import DocumentViewPro from './DocumentViewPro';

const ComparePage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const leftDocId = searchParams.get('left');
  const rightDocId = searchParams.get('right');

  if (!leftDocId || !rightDocId) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="info">
          <Typography variant="body2">
            Compare requires two documents. Use URL: /compare?left=docId1&right=docId2
          </Typography>
        </Alert>
      </Box>
    );
  }

  return (
    <Box sx={{
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      height: 'calc(100vh - 64px)',
      gap: 0,
    }}>
      {/* Left document */}
      <Box sx={{ borderRight: '2px solid #1A2341', overflow: 'hidden' }}>
        <DocumentViewPro docIdProp={leftDocId} />
      </Box>

      {/* Right document */}
      <Box sx={{ overflow: 'hidden' }}>
        <DocumentViewPro docIdProp={rightDocId} />
      </Box>
    </Box>
  );
};

export default ComparePage;
